import { Injectable } from '@angular/core';
import { Response } from '@angular/http';

@Injectable()
export class AutoMapperService {

    public parseResponse<T>(type: { new (): T; }, response: Response): any {
        let data: any = response.json();
        return this.parse(type, data);
    }

    public parse<T>(type: { new (): T; }, data: any): any {
        if (data === null) {
            return new type();
        }
        if (Array.isArray(data)) {
            return data.map(x => this.map(new type(), x));
        }
        return this.map(new type(), data);
    }

    private map<T>(result: T, data: any): T {
        for (var prop in result) {
            let val = data[prop];
            if (result.hasOwnProperty(prop.toLowerCase()) && data.hasOwnProperty(prop.toLowerCase())) {

                let before = data[prop.toLowerCase()];

                if (typeof before === 'string' || before instanceof String) {

                } else if (typeof before === 'boolean'){

                } else if (typeof before === 'number') {

                }

                result[prop.toLowerCase()] = data[prop.toLowerCase()];
            }
        }
        return result;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/services/Common/auto-mapper.service.ts